var map = {
	"./beachBall.png": 26,
	"./bottle.png": 534,
	"./chess.png": 372,
	"./dise.png": 411,
	"./divesMask.png": 161,
	"./dynamite.png": 347,
	"./screwdriver.png": 418,
	"./toyAircraft.png": 146,
	"./toyTruck.png": 523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;